import { userStore } from '../store';
import { getKeyValue } from '../store/common/localStorageManager';
const ACCESS_MAP = { 'x-access-id':'userId', 'x-access-role':'role', 'x-access-role-id':'roleId',
  'x-access-tenant':'tenantId', 'x-access-token':'token', 'x-access-lang':'lang' } as const;

export const request = async ({
  url,
  method,
  data,
  headers,
  flag,
  isNotJsonType,
}: { url: string, method: string, data?: any, headers?: any, flag?: boolean,isNotJsonType?:boolean }) => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 30000); // ⏱ 设置30秒超时

  let _headers = {
    ...headers,
    ...Object.fromEntries(
        Object.entries(ACCESS_MAP).map(([h, k]) => [h, (userStore.state as any)[k] || getKeyValue(k)])
    ),
  };
  if (!isNotJsonType) {
    // 文件上传等非json格式
    _headers['Content-Type']='application/json'
  }
  let host = _get(window, "application_config.WEB_API_HOST") || _get(window, "location.ancestorOrigins[0]");
  let address = `${host}/web-api${url}`;
  if (url.startsWith("http")){
    address = url
  }

  try {
    let response = await fetch(address, {
      method: method,
      headers: _headers,
      body: flag ? data : JSON.stringify(data),
      signal: controller.signal // ✅ 加入 signal
    });
    clearTimeout(timeout); // ✅ 清除定时器.
    return await response.json();
  } catch (err) {
    clearTimeout(timeout); // ✅ 确保异常时也清除定时器
    console.error("请求失败或超时:", err);
    throw err;
  }
};



export const JSON_HEADER = () => {
  return {
    'Content-Type': 'application/json'
  }
}
export const requestHeaders = () => {
  return {
    'x-access-id': getKeyValue('userId'),
    'x-access-tenant': getKeyValue('tenantId'),
    'x-access-role-id': getKeyValue('roleId'),
    'x-access-role': getKeyValue('role'),
    'x-access-token': getKeyValue('token'),
  };
}



